import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import classnames from 'classnames';
import MenuCategories from './MenuCategories';

export default class MenuDirectory extends React.Component {
  constructor(props) {
    super(props);
  }

  menuObj = [
    {
      name: 'How to use the directory',
      url: '/global-resource-directory',
      slug: 'global-resource-directory',
      isExternalUrl: false,
      hover: false
    },
    // Removed 2023-01-06: Main categories in drop down
    {
      name: 'Search by category',
      url: '#',
      slug: 'categories',
      isExternalUrl: false,
      hover: true
    },
  ];

  componentWillMount() {
    const parentCloseFuncCall = this.props.parentCloseFuncCall;
  }

  handleLinkClick = (e) => {
    this.parentCloseFuncCall();
  }

  render() {
    const { rootCategories, categoriesMenuState, menuCategoryClasses, iconCategoryClasses, parentCloseFuncCall, browser, menuState } = this.props;

    let linkPath;
    let iconPath;
    let bufferDiv = '';

    if (browser.greaterThan.desktop) {
      bufferDiv = <div className="bufferDiv"><img border="0" width="100" height="30" src="/images/1px_shim.png" /></div>
    } else {
      bufferDiv = <div className="bufferDiv"><img border="0" width="100" height="10" src="/images/1px_shim.png" /></div>
    }

    let menuLinks = this.menuObj.map((menuLink, index) =>{
        linkPath = menuLink.url;

        if (menuLink.hover) {

          return <li onClick={this.toggleCategories} className="mainMenu-subCategory searchDirectory" key={menuLink.slug}>


            <div className="mainMenu-subNavLinkWrapper">
              <div className="mainMenu-subNavLink"><Link className={menuCategoryClasses}  to={`${menuLink.url}`}>{menuLink.name} <i className={iconCategoryClasses}></i></Link></div>
              {bufferDiv}
            </div>



            <div className="mainMenuSubDropDownWrapper menuCategories">


              <MenuCategories
                rootCategories={rootCategories}
                categoriesMenuState = {categoriesMenuState}
                parentCloseFuncCall = {parentCloseFuncCall}
                browser = {browser}
              />

            </div>

          </li>

        } else {
          return <li key={menuLink.slug}>
            <div className="mainMenu-subNavLinkWrapper">
              <div className="mainMenu-subNavLink"><Link to={linkPath} onClick={this.handleLinkClick}>{menuLink.name}</Link></div>
            </div>
          </li>
        }

    }); // End: Mapping

    let menuLinksWrapper = <ul className="subNavDirectory">{menuLinks}</ul>;

    let directoryMenu;


    if (menuState && !browser.greaterThan.desktop) {
      directoryMenu = <div className="mainMenuDropDownInnerWrapper">
        <div className="mainMenuDropDown">{menuLinksWrapper}</div>
      </div>
    } else if (browser.greaterThan.desktop) {
      directoryMenu = <div className="mainMenuDropDownInnerWrapper directoryMenuInnerWrapper">
        <div className="mainMenu-subNavPointer">
          <img src="/images/subnav/subnav_pointer_bkgd.png" />
        </div>
        <div className="mainMenuDropDown directoryMenuInnerInnerWrapper">{menuLinksWrapper}</div>
      </div>
    }

    return(
      <div>
        {directoryMenu}
      </div>
    );
  }
}

MenuDirectory.propTypes = {
  menuState: PropTypes.bool.isRequired,
  parentCloseFuncCall: PropTypes.func.isRequired,
  browser: PropTypes.object,
  rootCategories: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/header/MenuDirectory.jsx